import { ReactComponent as MenuIcon } from "./menu.svg";

import Icon from "../Icon";

export default MenuIcon as any as Icon;
